import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorStaking = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M18.744 2.25c-.886 0-1.666.46-2.112 1.157a.75.75 0 1 1-1.264-.809 4.006 4.006 0 1 1 5.533 5.533.75.75 0 1 1-.808-1.263 2.506 2.506 0 0 0-1.349-4.618ZM22.75 21.5A1.75 1.75 0 0 1 21 23.25H3a1.75 1.75 0 0 1-1.75-1.75v-7c0-.966.784-1.75 1.75-1.75h1.5a.75.75 0 0 1 0 1.5H3a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25h18a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25h-1.5a.75.75 0 0 1 0-1.5H21c.966 0 1.75.784 1.75 1.75v7Z"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M5.45 11.35a6.5 6.5 0 1 1 9.516 5.76.75.75 0 0 0 .697 1.328 8 8 0 1 0-7.297.066.75.75 0 0 0 .673-1.34A6.5 6.5 0 0 1 5.45 11.35Zm10.61-1.16a.75.75 0 0 0-.53-.919l-2.359-.632a.75.75 0 1 0-.388 1.45l.557.148-1.473.933-.396-.34a.75.75 0 0 0-.936-.032l-2.783 2.07a.75.75 0 1 0 .895 1.204l2.303-1.713.362.31a.75.75 0 0 0 .89.065l1.957-1.24-.18.667a.75.75 0 1 0 1.45.388l.632-2.36Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M19.75 17.8a.75.75 0 0 1-.75.75H5a.75.75 0 1 1 0-1.5h14a.75.75 0 0 1 .75.75Z"
    />
  </svg>
);
export default SvgTwoColorStaking;
